import React, { useState, createContext, useEffect } from "react";
// utils
import axios from "../utils/axios";

export const CategoriesContext = createContext();

export const CategoriesProvider = (props) => {
  const [headerCategories, setHeaderCategories] = useState([]);

  useEffect(() => {
    axios
      .get(`/get-all-categories-tree`)
      .then((response) => response.data)
      .then((data) => setHeaderCategories(data.categories));
  }, []);

  return (
    <CategoriesContext.Provider value={{ headerCategories }}>
      {props.children}
    </CategoriesContext.Provider>
  );
};
